import { BrandliveEvent } from "../types/working-model";
import { removeStorageItem } from "./local-storage";
import { getSSOLogoutUrl } from "./sso-utils";

// this function will be moved into a larger registration utility file once registration refactor is completed
export const deregister = (eventBundle: BrandliveEvent): void => {
	removeStorageItem(`reg.${eventBundle?.uuid}`);
	removeStorageItem(`registration-step-${eventBundle?.uuid}`);
	removeStorageItem(`allowed.${eventBundle?.uuid}`);
	removeStorageItem('bl-profile');
	removeStorageItem('Bl-Profile-Token');
	removeStorageItem(`should-cont-reg-${eventBundle?.uuid}`);
	removeStorageItem(`all-steps-completed.${eventBundle?.event}`);
	removeStorageItem(`pageSession.${eventBundle?.event}`);


	const logoutUrl = getSSOLogoutUrl(eventBundle);

	if (logoutUrl) {
		window.location.href = logoutUrl;
	} else {
		window.location.reload();
	}
};
